module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/star-half-7dae8cae6042b75e829cba4a27b4acbe.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/star-half.svg
// module id = 1prn
// module chunks = 24